import AppDispatcher from '../dispatcher/app-dispatcher'


var ProductActions = {
	addProduct: function(product) {
		AppDispatcher.handleViewAction({
	      actionType: 'addProductToStore',
	      product: product
	    });
	}
};

export default ProductActions;
